import { Layout, LookupModelSelectionEvent } from "@mcleod/components";
import { Api, LogManager } from "@mcleod/core";
import { LMEGeneralSettings } from "@mcleod/general";
import { AutogenLayoutVoidOrderPrompt } from "./autogen/AutogenLayoutVoidOrderPrompt";
import { CommonDialogs } from "@mcleod/common";

const log = LogManager.getLogger("lme.dispatch.VoidOrderPrompt")
export class VoidOrderPrompt extends AutogenLayoutVoidOrderPrompt {
    private _orderId: string;
    private reasonRequired: boolean;
    success: boolean;
    onSave: (success: boolean, promptContent: VoidOrderPrompt) => void;

    override async onLoad(): Promise<void> {
        this.reasonRequired = "Y" === LMEGeneralSettings.getSingleton().getDispatchControl().enforce_void_hist
        this.textboxReasonCode.required = this.reasonRequired;
        this.textboxComments.required = this.reasonRequired;
        if (this.reasonRequired) {
            this.textboxReasonCode.visible = true;
            this.textboxComments.visible = true;
            this.textboxReasonCode.addLookupModelSelectionListener((event: LookupModelSelectionEvent) => {
                if (event.hasSelection() === true)
                    event.target.text = event.selection?.get("descr");
            });
            this.textboxReasonCode.addBeforeLookupModelSearchListener(event => {
                event.filter.is_active = "Y";
                event.filter.code_type = "V";
            })
        }

        //Search for carriers with advanced already listed for this order, and list those carries if found
        return Api.search("lme/dispatch/carriers-with-advances", { order_id: this.orderId })
            .then(resp => {
                const data = resp.data?.[0]
                if (data?.carriers && data.carriers.length > 0) {
                    this.advanceCarriersLabel.visible = true
                    this.advanceCarriersLabel.text =
                        `Advance(s) issued to:\n ${data.carriers.join(", ")}`
                }
            })
    }

    voidOrder() {
        if (!this.reasonRequired || this.validateSimple()) {
            return Api.post("lme/dispatch/void-order", {
                order_id: this.orderId,
                reason_code: this.textboxReasonCode.getFirstLookupModelData()?.get("id"),
                comment: this.textboxComments.text
            }, null, null).then(response => {
                this.success = response?.data[0]?.success;
                log.debug(`VOID was a ${this.success ? "success" : "failure"}!`)
                this.onSave(this.success, this)
            });
        }
    }

    get orderId(): string {
        return this._orderId
    }

    set orderId(value: string) {
        this._orderId = value
    }

    static async showPrompt(orderId: string, onSave: (success: boolean, promptContent: VoidOrderPrompt) => void) {
        const layout = Layout.getLayout("lme/dispatch/VoidOrderPrompt") as VoidOrderPrompt
        layout.orderId = orderId;
        layout.onSave = onSave;
        return CommonDialogs.showYesNo(layout, "Void Order", {
            yesButtonProps: {
                onClick: async () => layout.voidOrder()
            }
        });
    }
}
